import { ModuleElement } from '../../models/classes/module-element.model';

export function sortEntities(entityA: ModuleElement, entityB: ModuleElement): number {
  if (entityA.position == null || entityB.position == null) return 0;
  if (entityA.position < entityB.position) return -1;
  if (entityA.position > entityB.position) return 1;
  return 0;
}
